<template>
  <div class="min-h-screen bg-white">
    <slot />
  </div>
</template>

<script setup lang="ts">
// Layout minimal pour les pages de paiement externes - style Stripe
// Pas de navbar, pas de sidebar, fond blanc pur
</script>
